import { Component, OnInit,ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CommonApiService } from '../../common-api.service';
import { Note,knockOffdisplayColumns,knockOffdisplayHeaders } from './note.interface';
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { Router } from '@angular/router';
import { SnackbarService } from '../../snackbar.service';
import { MatSelect } from '@angular/material/select';
import { CommonDropdownService } from '../../common-dropdown.service';
import { environment } from "../../../../environments/environment";
import { tap, filter, finalize } from 'rxjs/operators';
import { Doctor } from '../doctor/doctor.interface';
import { SelectionModel } from '@angular/cdk/collections';
import { Company } from '../company/company.interface';
import { DateStorageService } from '../../date-storage.service';

@Component({
    selector: 'app-note.form',
    templateUrl: './note.form.component.html',
    styleUrls: ['./note.form.component.css']
})

export class NoteFormComponent implements OnInit {

    @ViewChild('doctor_id', { static: false }) doctor_id: MatSelect;
    @ViewChild('account_id', { static: false }) account_id: MatSelect;
    @ViewChild('company_id', { static: false }) company_id: MatSelect;
    constructor(
        private route: ActivatedRoute,
        private api: CommonApiService,
        private router: Router,
        public dialog: MatDialog,
        private snackbar: SnackbarService,
        private dropdownService: CommonDropdownService,
        private dateStorageService: DateStorageService
    ) { }

    public model = 'note'
    public note = {} as Note;
    isFormDisabled = true;
    result: string;
    onSaveDisable = false;

    public note_types : any[] = [ "debit", "credit"];
    public selected_note_type : string

    doctorSearchPage = 0;
    allDoctorsCount = 0
    public allDoctors: any[] = [];
    public selectedDoctor: number;
    public selectedDoctorObject: Doctor[] = [];
    disableDoctorSelection: boolean;

    accountSearchPage=0
    allAccountsCount = 0
    public allAccounts: any[] = [];
    public selectedAccount: number;
    public selectedAccountObject: any[] = [];
    disableAccountSelection: boolean;

    knockoffsDataSource:any = []
   
    displayHeaders = knockOffdisplayHeaders
    displayColumns = knockOffdisplayColumns
    displayColumnsWithSelect = ['select']

    selection = new SelectionModel<any>(true, []);
    knockOffSelected: any[] = [];

    companySearchPage=0
    allCompaniesCount = 0
    public allCompanies: any[] = [];
    public selectedCompany: number;
    public selectedCompanyObject: Company[] = [];
    disableCompanySelection: boolean;

    minDate: Date | null = new Date();
    maxDate: Date | null = new Date();

    ngOnInit() {
        this.disableCompanySelection=false
        this.disableDoctorSelection=false
        let note_Id = this.route.snapshot.params.id
        if (note_Id === 'create') {
            this.isFormDisabled = false;
        }
        else {  
            this.disableCompanySelection=true
            this.disableDoctorSelection=true          
            this.getNote(Number(note_Id));
        }
        this.onLoadDoctorList();
        // this.OnLoadAccountList();
        this.OnLoadCompanyList();
        this.displayColumnsWithSelect = this.displayColumnsWithSelect.concat(this.displayColumns);
        
        this.minDate = this.dateStorageService.getDateFromLocalStorage('fy_start_date')
        this.maxDate = this.dateStorageService.getDateFromLocalStorage('fy_end_date')
    }

    onDoctorKey(event: Event) {
        const value = (event.target as HTMLInputElement).value;
        this.dropdownService.updateSearchResults(value, 'doctor', this.allDoctors, this.selectedDoctorObject, 'doctorSearchPage')
          .subscribe((result: { entityList: any[], pageVariable: number }) => {
            this.allDoctors = result.entityList;
            this.doctorSearchPage = result.pageVariable;
        });
    }
    
    OnCompanyKey(event: Event) {
        const value = (event.target as HTMLInputElement).value;
        this.dropdownService.updateSearchResults(value, 'company', this.allCompanies, this.selectedCompanyObject, 'companySearchPage')
          .subscribe((result: { entityList: any[], pageVariable: number }) => {
            
            this.allCompanies = result.entityList;
            this.companySearchPage = result.pageVariable;
        });
    }

    onAccountKey(event: Event) {
        const value = (event.target as HTMLInputElement).value;
        this.dropdownService.updateSearchResults(value, 'account', this.allAccounts, this.selectedAccountObject, 'accountSearchPage')
          .subscribe((result: { entityList: any[], pageVariable: number }) => {
            this.allAccounts = result.entityList;
            this.accountSearchPage = result.pageVariable;
        });
    }

    onDoctorScroll(event:any) {

        if (!this.doctor_id?.panel || !this.doctor_id?.panel.nativeElement) {
            // Panel or nativeElement is not available, return or handle the situation accordingly.
            return;
        }
        if (event) {
            this.doctor_id.panel.nativeElement.addEventListener(
            'scroll',   
            (event: any) => {
                const tolerance = 10
                if (
                    Math.floor(this.doctor_id.panel.nativeElement.scrollTop) + tolerance >= 
                    Math.floor(this.doctor_id.panel.nativeElement.scrollHeight) -
                    Math.floor(this.doctor_id.panel.nativeElement.offsetHeight)
                    ){
                    let doctorparams = {
                        'pageIndex': this.doctorSearchPage,
                        'pageSize': environment.defaultPageSizeOnScroll
                    }
                    
                    if (this.allDoctors.length >= this.allDoctorsCount) {
                        return;
                    }
                    this.api.postAll('doctor/list/display', doctorparams).subscribe((res: any) =>{
                        res.items = res.items.filter((entity: any) => entity.id !== this.selectedDoctorObject[0]?.id);
                        this.allDoctors.push(...res.items);
                    });
                    this.doctorSearchPage++;// send page number for fetching the records
                }
            });
        }
    }

    OnCompanyScroll(event:any) {
        if (!this.company_id?.panel || !this.company_id?.panel.nativeElement) {
            // Panel or nativeElement is not available, return or handle the situation accordingly.
            return;
        }
        if (event) {
            this.company_id.panel.nativeElement.addEventListener(
            'scroll',   
            (event: any) => {
                const tolerance = 10
                if (
                    Math.floor(this.company_id.panel.nativeElement.scrollTop) + tolerance >= 
                    Math.floor(this.company_id.panel.nativeElement.scrollHeight) -
                    Math.floor(this.company_id.panel.nativeElement.offsetHeight)
                    ){
                    let companyparams = {
                        'pageIndex': this.companySearchPage,
                        'pageSize': environment.defaultPageSizeOnScroll
                    }
                    
                    if (this.allCompanies.length >= this.allCompaniesCount) {
                        return;
                    }
                    this.api.postAll('company/list/display', companyparams).subscribe((res: any) =>{
                        res.items = res.items.filter((entity: any) => entity.id !== this.selectedCompanyObject[0]?.id);
                        this.allCompanies.push(...res.items);
                    });
                    this.companySearchPage++;// send page number for fetching the records
                }
            });
        }
    }


    onAccountScroll(event:any) {
        if (!this.account_id?.panel || !this.account_id?.panel.nativeElement) {
            // Panel or nativeElement is not available, return or handle the situation accordingly.
            return;
        }
        if (event) {
            this.account_id.panel.nativeElement.addEventListener(
            'scroll',   
            (event: any) => {
                const tolerance = 10
                if (
                    Math.floor(this.account_id.panel.nativeElement.scrollTop) + tolerance >= 
                    Math.floor(this.account_id.panel.nativeElement.scrollHeight) -
                    Math.floor(this.account_id.panel.nativeElement.offsetHeight)
                    ){
                    let accountparams = {
                        'pageIndex': this.accountSearchPage,
                        'pageSize': environment.defaultPageSizeOnScroll
                    }
                    
                    if (this.allAccounts.length >= this.allAccountsCount) {
                        return;
                    }
                    this.api.postAll('account/list/display', accountparams).subscribe((res: any) =>{
                        res.items = res.items.filter((entity: any) => entity.id !== this.selectedAccountObject[0]?.id);
                        this.allAccounts.push(...res.items);
                    });
                    this.accountSearchPage++;// send page number for fetching the records
                }
            });
        }
    }


    // On load of component default pageSize for dropdown to load and also set selected value if present
    onLoadDoctorList() {
        let params = {
            'pageIndex': this.doctorSearchPage,
            'pageSize': environment.defaultPageSizeOnScroll
        }

        this.api.postAll('doctor/list/display', params).pipe(
            tap((res: any) => {
                this.allDoctors.push(...res.items);
                this.allDoctorsCount = res.rowCount
            }),
            filter(() => this.selectedDoctorObject.length !== 0),
            tap(() => {
              const selectedDoctorId = this.selectedDoctorObject[0].id;
              this.allDoctors = this.allDoctors.filter(doctor => doctor.id !== selectedDoctorId);
              this.allDoctors.unshift(this.selectedDoctorObject[0]);
              
            }),
            finalize(() => this.doctorSearchPage++)
        ).subscribe();
    }

    OnLoadCompanyList() {
        this.api.getAll('company').pipe(
            tap((res: any) => {
                this.allCompanies=res
            }),
            filter(() => this.selectedCompanyObject.length !== 0),
            tap(() => {
              const selectedCompanyId = this.selectedCompanyObject[0].id;
              this.allCompanies = this.allCompanies.filter(company => company.id !== selectedCompanyId);
              this.allCompanies.unshift(this.selectedCompanyObject[0]);
              
            }),
        ).subscribe();
    }

    OnLoadAccountList() {
        let params = {
            'pageIndex': this.accountSearchPage,
            'pageSize': environment.defaultPageSizeOnScroll,
            'filterCriteria': {
                'company_id': ['dropdown', this.selectedCompany],
                'type': ['=', ['other']],
                "order_by_columns": [
                    "multi_select",
                    null
                ],
                "order_by": "asc"
            }
        }
        this.api.postAll('account/list/display', params).pipe(
            tap((res: any) => {
                this.allAccounts.push(...res.items);
                this.allAccountsCount = res.rowCount
            }),
            filter(() => this.selectedAccountObject.length !== 0),
            tap(() => {
              const selectedAccountId = this.selectedAccountObject[0].id;
              this.allAccounts = this.allAccounts.filter(account => account.id !== selectedAccountId);
              this.allAccounts.unshift(this.selectedAccountObject[0]);
              
            }),
        ).subscribe();
    }

    getNote(note_Id: number) {
        this.api.get(this.model, note_Id).subscribe(
            (data: any) => {
                if (data) {
                    this.note = data;
                    this.selected_note_type = data.note_type

                    this.selectedDoctor = data.doctor.id;
                    this.allDoctors = this.allDoctors.filter(doctor => doctor.id !== data.doctor.id);
                    this.allDoctors.push(data.doctor) // insert specific selected doctor into the dropdown list
                    this.selectedDoctorObject.push(data.doctor)

                    this.selectedAccount = data.account.id;
                    this.selectedAccountObject.push(data.account)

                    this.selectedCompany = data.company.id;
                    this.OnLoadAccountList();
                    this.allCompanies = this.allCompanies.filter(company => company.id !== data.company.id);
                    this.allCompanies.push(data.company) // insert specific selected doctor into the dropdown list
                    this.selectedCompanyObject.push(data.company)

                    this.getKnockOffsList(data.doctor.id,data.account.id,data.note_type)
                
                }
            }
        );
    }

    

    save(formValid:any) {
        if(formValid == false){
            this.snackbar.warning("Please fill mandatory fields.");
            return;
        }
        if (this.selectedCompany == undefined) {
			this.snackbar.warning("Please select company.");
			return;
		}
        if (this.selected_note_type == undefined) {
			this.snackbar.warning("Please select note type.");
			return;
		}
        this.note.note_type   = this.selected_note_type
        this.note.account_id=this.selectedAccount
        this.note.doctor_id=this.selectedDoctor
        this.note.company_id=this.selectedCompany
        this.note.knock_offs=this.knockOffSelected
        this.onSaveDisable = true;
        
        this.api.createUpdate(this.model, this.note).subscribe(
            (data: any) => {
                if (data) {
                    this.note = data;
                    this.isFormDisabled = true;
                    this.snackbar.success('Saved Successfully!');
                    this.onSaveDisable = false;
                    // Refresh knockoff list to show updated balances
                    if (this.selectedDoctor && this.selectedAccount && this.selected_note_type) {
                        this.knockOffSelected = [];
                        this.getKnockOffsList(this.selectedDoctor, this.selectedAccount, this.selected_note_type);
                    }
                }

                this.api.refreshNeeded.subscribe(() => {
                    this.getNote(Number(this.note.id));
                });
            },
            error => {
                this.snackbar.error(error.error.message)
                this.onSaveDisable = false;
            }
        );
    }
    edit(){
        this.isFormDisabled = false;
        this.disableCompanySelection=true
        this.disableDoctorSelection=true
    }

    discardChanges(): void {
		const message = `Are you sure you want to discard the changes?`
		const dialogConfig = new MatDialogConfig();
		dialogConfig.data = {
			title: "Discard Changes",
			message: message
		}
		const dialogRef = this.dialog.open(ConfirmDialogComponent, dialogConfig);
		dialogRef.afterClosed().subscribe(dialogResult => {
			this.result = dialogResult;
			// return true or false or undefined , hence we can handle the functionality on true and false likewise here
			if (this.result) {
                if(this.note.id){
                    this.isFormDisabled = true;
                    this.getNote(this.note.id);
                }else{
                    this.router.navigate([`/note`]);
                }
			}
		});
	}

    calculateNoteTaxes(note:any) {
        if (this.selectedAccount == undefined || this.selectedDoctor == undefined) {
            return
        }
        const payload = {
            account_id: this.selectedAccount,
            doctor_id: this.selectedDoctor,
            amount: this.note.amount,
        }
		note.doctor_id = this.selectedDoctor
		// note.company_id = this.selectedCompany
		this.api.callRoute(this.model, '/calculateTax', payload).subscribe(
			(data: any) => {
                console.log(data)
				this.note.sgst = data.sgst;
				this.note.cgst = data.cgst;
				this.note.igst = data.igst;
				this.note.sgst_amount = data.sgst_amount;
				this.note.cgst_amount = data.cgst_amount;
				this.note.igst_amount = data.igst_amount;
				this.note.grand_total = data.grand_total;
                this.note.amount=data.amount;
					
			}
		);
	}

    onAccountOrDoctorChange() {
        if (this.note.amount){
            this.calculateNoteTaxes(this.note)
        }
		
        if (this.selectedAccount != undefined && this.selectedDoctor != undefined) {
            this.getKnockOffsList(this.selectedDoctor, this.selectedAccount,this.selected_note_type)
        }  
	}

    create(){
        this.redirectTo('note/create');
    }



    //redirects to the expected route
    //this function will redirect to a dummy route and quickly return to the destination route without the user realizing it.
    redirectTo(uri:string){  
        this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=>
        this.router.navigate([uri]));
    }

    confirmDialog(note_id: number, state:string): void {

		var dialog_message = '';
		if(state == 'submit') {
			dialog_message = 'Submit';
		} else if(state == 'cancel') {
			dialog_message = 'Cancel';
		}

		const message = 'Are you sure you want to '+dialog_message+' note?'
		const dialogConfig = new MatDialogConfig();
		dialogConfig.data = {
			title: dialog_message+" note",
			message: message
		}
		const dialogRef = this.dialog.open(ConfirmDialogComponent, dialogConfig);
		dialogRef.afterClosed().subscribe(dialogResult => {
			this.result = dialogResult;
			// return true or false or undefined , hence we can handle the functionality on true and false likewise here
			if (this.result) {
				if (state == 'submit') {
					this.submitNote(note_id);
				} else if(state == 'cancel'){
					this.cancelNote(note_id);
				}
			}
		});
	}

    submitNote(note_id: number) {
		this.api.callRoute('note', `/submit/${note_id}`, null).subscribe(
			(data: any) => {
				if (data) {
					this.note = data;
					this.isFormDisabled = true;
					this.snackbar.success('Submitted Successfully!');
				}
			},
			error => {
				this.snackbar.error(error.error.message)
				console.log(error)
			}
		);
	}


	cancelNote(note_id: number) {
		this.api.callRoute('note', `/cancel/${note_id}`, null).subscribe(
			(data: any) => {
				if (data) {
					this.note = data;
					this.isFormDisabled = true;
					this.snackbar.success('Cancelled Successfully!');
				}
			},
			error => {
				this.snackbar.error(error.error.message)
				console.log(error)
			}
		);
	}

    getKnockOffsList(doctorId:number,accountId:number,type:string){
        this.api.getAll("account_knock_off/list/note",{"doctor_id": doctorId, "account_id": accountId,"type":type} ).subscribe(
            (data: any) => {
                if (data) {
                    this.knockoffsDataSource=data
                    this.selection.clear();
                    if (this.note.knocked_off != undefined && this.note.knocked_off.length > 0) {
                        
                    this.note.knocked_off.forEach((accReceipt: any) => {
                        
                        // Push the default selected items to knockOffSelected array
                        this.knockOffSelected.push({
                            "id": accReceipt.for_object.id,
                            "type": accReceipt.for_object.type
                        });
                        // Select the default items in MatTable selection

                        const exists = this.knockoffsDataSource.find((row: any) => row.id === accReceipt.for_object.id && row.type === accReceipt.for_object.type);
                        if (!exists) {                            
                            this.knockoffsDataSource = this.knockoffsDataSource.concat({
                                "id": accReceipt.for_object.id,
                                "type": accReceipt.for_object.type,
                                "name": accReceipt.for_object.name,
                                "date": accReceipt.for_object.date,
                                "amount": accReceipt.for_object.amount,
                                "balance": accReceipt.for_object.balance
                            });
                        }


                        const selectedRow = this.knockoffsDataSource.find((row: any) => row.id === accReceipt.for_object.id && row.type === accReceipt.for_object.type);
                        if (selectedRow) {
                            this.selection.select(selectedRow);
                        }
                        
                    });
                }

                }
            }
        );
    }


    isAllSelected() {
		const numSelected = this.selection.selected.length;
		const numRows = this.knockoffsDataSource.filteredData.length;
		return numSelected === numRows;
	}

    toggleSelection(row: any) {
		this.selection.toggle(row);
		if (this.selection.isSelected(row)) {
		  this.knockOffSelected.push({
            'id': row.id,
            'type': row.type
          });
		} else {
        
            var index = this.knockOffSelected.findIndex((item: any) => item.id === row.id && item.type === row.type);
            while (index > -1) {                
                var index = this.knockOffSelected.findIndex((item: any) => item.id === row.id && item.type === row.type);
                if (index > -1) {
                  this.knockOffSelected.splice(index, 1); // Remove ID if it's deselected                            
                }
            }
		}
	}
    
    onDoctorOrAccountChange(){
        if (this.selectedAccount != undefined && this.selectedDoctor != undefined) {
            this.getKnockOffsList(this.selectedDoctor, this.selectedAccount,this.selected_note_type)
        }  
    }

    onCompanyChange() {        
        this.allAccounts = [];
        this.selectedAccountObject = [];
        this.OnLoadAccountList();
    }

}
